// @ts-nocheck
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { CategoryCollectionModel } from "@insite/client-framework/Types/ApiModels";

interface PromotionTreeApiParameter extends ApiParameter {
    leafCategoryIds: string[];
}
const promotionTreeEndpoint = "/api/v1/promotiontree";

export const getPromotionTree = (parameter: PromotionTreeApiParameter): Promise<CategoryCollectionModel> => {
    return post<PromotionTreeApiParameter, CategoryCollectionModel>(promotionTreeEndpoint, parameter);
};
